/** CFP session topic helpers. Topic copy comes from GET /api/content (`cfp_session_topics`). */

export function getSegmentById(segments, segmentId) {
  const list = Array.isArray(segments) ? segments : [];
  if (!list.length) return null;
  return list.find((segment) => segment.id === segmentId) ?? list[0];
}

export function defaultCfpSegmentId(segments) {
  return getSegmentById(segments, '')?.id || '';
}

export function formatCfpSessionTopic(tabLabel, topicCardTitle) {
  const label = String(tabLabel ?? '').trim();
  const title = String(topicCardTitle ?? '').trim();
  if (label && title) return `${label} - ${title}`;
  return title || label;
}

export function resolveSelectedCfpTopic(segments, selectedTopicIds, segmentId) {
  const list = Array.isArray(segments) ? segments : [];
  if (!selectedTopicIds?.length || !list.length) return null;
  const topicId = selectedTopicIds[0];

  if (segmentId) {
    const segment = list.find((item) => item.id === segmentId);
    const topic = segment?.topics?.find((item) => item.id === topicId);
    if (!topic || !segment) return null;
    return {
      tabLabel: segment.label,
      topicCardTitle: topic.title,
      topic: formatCfpSessionTopic(segment.label, topic.title),
    };
  }

  for (const segment of list) {
    const topic = segment.topics?.find((item) => item.id === topicId);
    if (topic) {
      return {
        tabLabel: segment.label,
        topicCardTitle: topic.title,
        topic: formatCfpSessionTopic(segment.label, topic.title),
      };
    }
  }
  return null;
}

export function resolveTopicIdFromTopicName(segments, topicName) {
  const name = String(topicName ?? '').trim();
  const list = Array.isArray(segments) ? segments : [];
  if (!name || !list.length) return null;

  for (const segment of list) {
    for (const topic of segment.topics || []) {
      const formatted = formatCfpSessionTopic(segment.label, topic.title);
      if (formatted === name) {
        return { topicId: topic.id, segmentId: segment.id };
      }
    }
  }

  return null;
}
